import DashboardIcon from "@mui/icons-material/Dashboard";
import EmojiFlagsIcon from "@mui/icons-material/EmojiFlags";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import PersonIcon from "@mui/icons-material/Person";
import PlaceIcon from "@mui/icons-material/Place";
import GroupIcon from "@mui/icons-material/Group";
import LogoutIcon from "@mui/icons-material/Logout";
import SchoolIcon from "@mui/icons-material/School";
import TopicIcon from "@mui/icons-material/Topic";
import BuildIcon from "@mui/icons-material/Build";
import GridOnIcon from "@mui/icons-material/GridOn";
import FolderSpecialIcon from "@mui/icons-material/FolderSpecial";
import WorkIcon from "@mui/icons-material/Work";
import PermContactCalendarIcon from "@mui/icons-material/PermContactCalendar";
import { Stack, Typography } from "@mui/material";

import { CalendarViewMonth } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { Feature } from "../../models/api";
import React from "react";
import useApp from "../../hooks/useApp";

interface Props {
  name: string;
  icon: string;

  selectedFeature?: Feature;
  color: "black" | "white";
  slug?: string;
  action?: () => void;
  setOpenDrawer?: React.Dispatch<React.SetStateAction<boolean>>;
  onSelectUnLinkFeature?: (feature: any) => void;
  open?: boolean;
}

const SubMenuItem: React.FC<Props> = ({
  name,
  icon,
  color,
  slug,
  setOpenDrawer,
  open = true,
}) => {
  const { currentRoute, push } = useApp();
  const isSelected = currentRoute === `/${slug!}`;


  const renderIcon = (icon: string): React.ReactNode => {
    if (icon === "DashboardIcon")
      return (
        <DashboardIcon
          sx={{ fill: color === "white" ? "#FFFFFF" : "#232323" }}
        />
      );

    if (icon === "GridIcon")
      return (
        <GridOnIcon sx={{ fill: color === "white" ? "#FFFFFF" : "#232323" }} />
      );

    if (icon === "DepartIcon")
      return (
        <FolderSpecialIcon
          sx={{ fill: color === "white" ? "#FFFFFF" : "#232323" }}
        />
      );

    if (icon === "JobsIcon")
      return (
        <WorkIcon sx={{ fill: color === "white" ? "#FFFFFF" : "#232323" }} />
      );

    if (icon === "RolesIcon")
      return (
        <PermContactCalendarIcon
          sx={{ fill: color === "white" ? "#FFFFFF" : "#232323" }}
        />
      );

    if (icon === "CalenderIcon")
      return (
        <CalendarViewMonth
          sx={{ fill: color === "white" ? "#FFFFFF" : "#232323" }}
        />
      );

    if (icon === "LogoutIcon")
      return (
        <LogoutIcon sx={{ fill: color === "white" ? "#FFFFFF" : "#232323" }} />
      );
    if (icon === "EmojiFlagsIcon")
      return (
        <EmojiFlagsIcon
          sx={{ fill: color === "white" ? "#FFFFFF" : "#232323" }}
        />
      );
    if (icon === "LocationCityIcon")
      return (
        <LocationCityIcon
          sx={{ fill: color === "white" ? "#FFFFFF" : "#232323" }}
        />
      );
    if (icon === "AccountBoxIcon")
      return (
        <AccountBoxIcon
          sx={{ fill: color === "white" ? "#FFFFFF" : "#232323" }}
        />
      );
    if (icon === "GroupIcon")
      return (
        <GroupIcon sx={{ fill: color === "white" ? "#FFFFFF" : "#232323" }} />
      );
    if (icon === "PlaceIcon")
      return (
        <PlaceIcon sx={{ fill: color === "white" ? "#FFFFFF" : "#232323" }} />
      );
    if (icon === "PersonIcon")
      return (
        <PersonIcon sx={{ fill: color === "white" ? "#FFFFFF" : "#232323" }} />
      );
    if (icon === "SchoolIcon")
      return (
        <SchoolIcon sx={{ fill: color === "white" ? "#FFFFFF" : "#232323" }} />
      );
    if (icon === "TopicIcon")
      return (
        <TopicIcon sx={{ fill: color === "white" ? "#FFFFFF" : "#232323" }} />
      );
    if (icon === "BuildIcon")
      return (
        <BuildIcon sx={{ fill: color === "white" ? "#FFFFFF" : "#232323" }} />
      );

    return null;
  };

  const handleClick = () => {
    push(`/${slug!}`);
    if (setOpenDrawer) setOpenDrawer(false);
  };
  const { t } = useTranslation();

  return (
    <Stack
      component={slug ? "a" : "button"}
      direction={"row"}
      alignItems={"unset"}
      bgcolor={
        isSelected
          ?  "sideMenu.selected"
          : "transparent"
      }
      px={3}
      border={"none"}
      borderRadius={1}
      onClick={handleClick}
      sx={{
        transition: "500ms",
        "&:hover": {
          bgcolor : "sideMenu.selected",
        },
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
      }}
    >
      <Typography style={{ display: "flex", gap: "5px" }}>
        {renderIcon(icon)}
        {open && (
          <Typography
            variant="body1"
            fontWeight={500}
            color={"sideMenu.text"}
            sx={{
              mx: 2,
              minWidth: 200,
            }}
          >
            {t(name)}
          </Typography>
        )}
      </Typography>
    </Stack>
  );
};

export default SubMenuItem;
